(function () {
    'use strict';
    var m = angular.module('app');
    m.controller('DualAppModalController', ["$scope", "$modalInstance", "args", "dualAppHelper", "$rootScope", "$cookies", "autologinHelper", "feature", function ($scope, $modalInstance, args, dualAppHelper, $rootScope, $cookies, autologinHelper, feature) {
        var checkModule = dualAppHelper.checkDualApp(args.moduleName);
        $scope.authName = checkModule.authName;
        $scope.autologinCP = autologinHelper.enabled() || $cookies.get('autologinCP');
        $scope.loading = false;
        $scope.model = args;
        if (args.currentStep === -1) {
            $scope.currentStep = args.currentStep + 2;
        } else {
            $scope.currentStep = args.currentStep + 1;
        }
        try {
            dualAppHelper.getAuthObject($scope.authName, args.moduleName, args.mode).then(function (response) {
                $scope.model.auth = response.data;
                $scope.currentUIOptions = $scope.model.auth.steps[$scope.currentStep];
                if ($scope.model.auth.type === 'dual-app-authorization') {
                    $scope.loading = false;
                }
            });
        } catch (err) {
            console.log('--DualAppModalController--', err);
        }
        var brand = 'avanan';
        if (feature.checkpointTheme) {
            brand = 'checkpoint';
        } else if (feature.sonicwallTheme) {
            brand = 'SonicWall';
        }
        var serviceUser = brand + '-service-user';
        if ($scope.authName === 'gsuite') {
            serviceUser = 'cloud-sec-av';
        }
        $scope.warningMessage = 'Once you complete authorization, a new system user will be created- <br><strong>' + serviceUser + '@yourdomain.com</strong>';
        if ($scope.authName === 'gsuite') {
            $scope.warningMessage += '<br>Note - that user requires an additional un-assigned license.';
        } else {
            $scope.warningMessage += '<br>That user does not require an additional license.';
        }
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
        $scope.ok = function () {
            executeDualOperation($scope.model);
            $modalInstance.close();
        };
        function executeDualOperation(app) {
            window.localStorage.setItem('dualAuthStarted', JSON.stringify({
                path: window.location.href,
                saas: app.moduleName,
                mode: app.mode ? app.mode : 'normal'
            }));
            // checking if we're inside an iframe
            if (window.self !== window.top) {
                $rootScope.$broadcast('dual-auth-started-' + $scope.currentStep);
                window.open(app.auth.steps[$scope.currentStep].auth_link, '_blank').focus();
            } else {
                window.location.href = app.auth.steps[$scope.currentStep].auth_link;
            }
        }
    }]);
    m.factory('dualAppModal', ["$modal", "path", function ($modal, path) {
        return {
            show: function (args) {
                var modalConfig = {
                    templateUrl: path('common').ctrl('dual-app-modal').template(),
                    controller: 'DualAppModalController',
                    resolve: { args: _.constant(args.moduleInfo) }
                };
                var modalInstance = $modal.open(modalConfig);
                return modalInstance.result;
            }
        };
    }]);
}());